import Headings from 'admin/components/atoms/Headings';
import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { InputErrors } from './WithErrors';

type Props = {
  isModalOpen: boolean;
  closeModal?: React.ComponentPropsWithoutRef<typeof Modal>['onRequestClose'];
  title?: string;
  form?: React.ReactNode;
  errors?: React.ComponentPropsWithoutRef<typeof InputErrors>['errors'];
};

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-30%',
    transform: 'translate(-50%, -50%)',
  },
};

const ConfirmModal = ({ isModalOpen, closeModal, title, form, errors }: Props) => (
  <InputErrors errors={errors}>
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick
      closeTimeoutMS={200}
      ariaHideApp={false}
      style={modalStyles}
    >
      <div style={{ textAlign: 'center' }}>
        <Headings.h5>{title}</Headings.h5>
      </div>
      {form}
    </Modal>
  </InputErrors>
);

export default styled(ConfirmModal)``;
